export default __webpack_public_path__ + "static/media/speaker info.30c613bd.jpg";